// extracted by mini-css-extract-plugin
export default {"wrapper":"NavigationTabs_wrapper__Q9+uP","item":"NavigationTabs_item__u356J"};